// 3p
import { connect } from 'react-redux';
import { EditorState } from 'draft-js';
import React from 'react';

// Fp
import { DRAFT_CONTENT_CHANGE } from '../../constants';
import StyledEditor from './StyledEditor';

class DraftEditor extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.state = {};
  }

  /**
   * Sets up initial editor state based on content prop which is a ContentState entity
   */
  componentWillMount() {
    if (this.props.content) {
      this.state = { editorState: EditorState.createWithContent(this.props.content) };
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.content === null && nextProps.content) {
      this.setState({
        editorState: EditorState.createWithContent(nextProps.content)
      });
    }
  }

  /**
   * Broadcasts current content via onChange
   * internally sets the new editorState
   */
  onChange(editorState) {
    this.props.onChange(editorState.getCurrentContent());
    this.setState({ editorState });
  }

  render() {
    const {editorState} = this.state;

    if (!editorState) {
      return <span>Loading</span>;
    }

    return <StyledEditor editorState={editorState} onChange={this.onChange} />;
  }
}

const mapStateToProps = (state) => {
  return {
    content: state.draft.content
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onChange: (content) => dispatch({ type: DRAFT_CONTENT_CHANGE, content })
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DraftEditor);



/** WEBPACK FOOTER **
 ** ./src/components/pages/DraftEditor.js
 **/